import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const SaintVincent: Country = {
    identifier: "SaintVincent",
    name: "Saint Vincent and the Grenadines",
    countryCode: "VC",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: true,
    flag: "🇻🇨",
    svgPath: "m 303.20975,425.9094 -0.083,0.045 -0.206,-0.192 0.025,-0.224 0.125,-0.123 0.118,-0.072 0.121,-0.008 0.042,0.185 -0.029,0.261 -0.113,0.128 z m -0.145,0.468 -0.045,0.031 0.021,0 -0.021,0.021 -0.014,-0.021 -0.022,-0.013 -0.028,-0.006 -0.033,10e-4 0,-0.021 0.042,0.013 0.063,-0.013 0,-0.023 -0.019,-0.021 -0.008,-0.015 0.023,-0.022 0.078,-0.05 0.033,-0.026 0.004,0.011 10e-4,0.01 0.004,0.01 0.012,0.01 -0.04,0.039 -0.051,0.085 z m -0.304,0.857 -0.028,0.001 -0.025,-0.01 0.007,-0.009 0.032,-0.007 0.015,-0.019 -0.005,-0.025 10e-4,-0.028 0.025,-0.017 0.02,-0.001 0.009,0.011 0.005,0.026 -0.015,0.02 -0.017,0.016 -0.008,0.025 -0.016,0.017 z",
}
